import type { ReactNode } from 'react';
import type { AssistantTargetKey } from './assistantTargetKeys';
import { useAssistantTarget } from './useAssistantTarget';

interface AssistantTargetRegionProps {
  targetKey: AssistantTargetKey;
  entityId?: string | null;
  className?: string;
  children: ReactNode;
}

export function AssistantTargetRegion({
  targetKey,
  entityId = null,
  className,
  children,
}: AssistantTargetRegionProps) {
  const targetRef = useAssistantTarget(targetKey, entityId);
  return (
    <div ref={targetRef} className={className}>
      {children}
    </div>
  );
}
